import { render, staticRenderFns } from "./VcaTemperature.vue?vue&type=template&id=039f814c&scoped=true"
import script from "./VcaTemperature.vue?vue&type=script&lang=ts"
export * from "./VcaTemperature.vue?vue&type=script&lang=ts"
import style0 from "./VcaTemperature.vue?vue&type=style&index=0&id=039f814c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f814c",
  null
  
)

export default component.exports